import React, { useEffect, useState } from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import AgreementsTable from './AgreementsTable';
import AgreementsDrawer from './AgreementsDrawer';
import { getRequest } from 'api/apiClient';
import { Agreement } from 'types/agreementTypes';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Agreements: React.FC = () => {
    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [agreements, setAgreements] = useState<Agreement[]>([]);
    const [selectedAgreement, setSelectedAgreement] = useState<Agreement | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const { t } = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const agreements = await getRequest(`/orgs/${orgId}/termsAgreements`);
                const filteredAgreements = agreements.data.filter((agreement: Agreement) => agreement.status === 1);
                setAgreements(filteredAgreements);
            } catch (error) {
                console.log("Failed to fetch data.");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [orgId]);

    const handleEditClick = (agreement: Agreement) => {
        setSelectedAgreement(agreement);
        setDrawerOpen(true);
    };

    const handleAddClick = () => {
        setSelectedAgreement(null);
        setDrawerOpen(true);
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
        setSelectedAgreement(null);
    };

    return (
        <OpPage title={t('agreement.title')} tooltip={t('agreement.tooltip')}>
            <AgreementsTable
                agreements={agreements}
                loading={loading}
                setAgreements={setAgreements}
                handleEditClick={handleEditClick}
                handleAddClick={handleAddClick}
            />
            <AgreementsDrawer
                open={drawerOpen}
                selectedAgreement={selectedAgreement}
                onClose={handleDrawerClose}
                setAgreements={setAgreements}
            />
        </OpPage>
    );
}

export default Agreements;
